import React, { useContext } from 'react';
import { CartContext } from "../Context/CartContext";
import { useNavigate } from "react-router-dom";
import { HOME_FURNITURE_IMAGES } from '../utils/imageUrls';

const projects = [
    {
        id: 1,
        title: "ספסל איקס דקורטיבי",
        mainImage: HOME_FURNITURE_IMAGES.decorativeBench,
        galleryImages: HOME_FURNITURE_IMAGES.decorativeBenchGallery,
        sizes: ['120X28, גובה: 45'],
        woodTypes: ['אורן'],
        price: "החל מ-₪400"
    },
    {
        id: 2,
        title: "שולחנות",
        mainImage: HOME_FURNITURE_IMAGES.homeTable,
        galleryImages: HOME_FURNITURE_IMAGES.homeTableGallery,
        sizes: [' שולחן ארוך-צר: 120X40, גובה 45','שולחן קפה: 80X50, גובה: 45'],
        woodTypes: ['אורן'],
        price: "החל מ-₪300"
    },
    {
        id: 3,
        title: "מיטות",
        mainImage: HOME_FURNITURE_IMAGES.bed,
        galleryImages: HOME_FURNITURE_IMAGES.bedGallery,
        sizes: ['מיטה בסיסית: גובה: 90, 200X80','מיטה נשלפת: גובה: 20, 190X80','מיטה מפנקת: גובה: 110, 200X80'],
        woodTypes: ['אורן'],
        price: "החל מ-₪400"
    },
    {
        id: 4,
        title: "ארונות",
        mainImage: HOME_FURNITURE_IMAGES.cabinet,
        galleryImages: HOME_FURNITURE_IMAGES.cabinetGallery,
        sizes: ['לבחירת הלקוח'],
        woodTypes: ['אורן'],
        price: "בהתאמה אישית"
    },
    {
        id: 5,
        title: "מדפים",
        mainImage: HOME_FURNITURE_IMAGES.shelves,
        galleryImages: HOME_FURNITURE_IMAGES.shelvesGallery,
        sizes: ['מדף קטן: 60X28', 'מדף בינוני: 90X28', 'מדף גדול: 180X28','מדף פינה:50X20','מדף תלוי: 95X15'],
        woodTypes: ['אורן'],
        price: "החל מ-₪350"
    },
    {
        id: 6,
        title: "חיפוי קירות",
        mainImage: HOME_FURNITURE_IMAGES.wallCovering,
        galleryImages: HOME_FURNITURE_IMAGES.wallCoveringGallery,
        sizes: ['לבחירת לקוח'],
        woodTypes: ['אורן'],
        price: "החל מ-₪165"
    },
    {
        id: 7,
        title: "מחזיק עצים ביתי",
        mainImage: HOME_FURNITURE_IMAGES.woodHolder,
        galleryImages: HOME_FURNITURE_IMAGES.woodHolderGallery,
        sizes: ['100X45, גובה: 100 '],
        woodTypes: ['אורן'],
        price: "החל מ-₪550"
    },
    {
        id: 8,
        title: "שידות",
        mainImage: HOME_FURNITURE_IMAGES.dresser,
        galleryImages: HOME_FURNITURE_IMAGES.dresserGallery,
        sizes: ['120X45, גובה: 70'],
        woodTypes: ['אורן'],
        price: "החל מ-₪1300"
    },
];

export { projects };

function HomeFurniture() {
    const { addToItem } = useContext(CartContext);
    const navigate = useNavigate();

    const handleClick = (project) => {
        addToItem(project);
        navigate(`/product-page/${project.id}`, { state: { project } });
    };

    return (
        <div className="py-10 px-4 sm:px-6 lg:px-8 bg-background flex flex-col items-center">

            <div className="text-center mb-16">
                <h1 className="text-3xl md:text-5xl font-medium text-text-primary tracking-wide mb-4">
                    ריהוט ביתי
                </h1>
                <div className="w-16 h-1 bg-accent mx-auto rounded-full"></div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 w-full max-w-7xl mx-auto">
                {projects.map(project => (
                    <div
                        key={project.id}
                        onClick={() => handleClick(project)}
                        className="group bg-surface rounded-2xl overflow-hidden shadow-soft hover:shadow-hover cursor-pointer transition-all duration-500 flex flex-col border border-transparent hover:border-secondary-dark"
                    >
                        <div className="relative aspect-[4/3] overflow-hidden bg-secondary">
                            <img
                                src={project.mainImage}
                                alt={project.title}
                                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-500" />
                        </div>

                        <div className="p-6 text-center flex flex-col flex-grow justify-between bg-surface z-10 relative">
                            <div>
                                <h2 className="text-xl md:text-2xl font-medium text-text-primary mb-1">
                                    {project.title}
                                </h2>
                                <p className="text-text-secondary text-sm font-light">
                                    {project.price}
                                </p>
                            </div>
                            <div className="w-8 h-0.5 bg-secondary-dark mx-auto mt-6 transition-all duration-300 group-hover:w-16 group-hover:bg-accent" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HomeFurniture;